import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=09bb52a5&lang=pug"
import script from "./ConfirmAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmAccount.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAccount.vue?vue&type=style&index=0&id=09bb52a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports